import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'partner': {
    title: '订单客户编码',
    type: 'dialog',
    equation: city,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'name': {
    title: '订单客户名称',
    width: 200
  },
  'productName': {
    title: '产品',
    width: 300
  },
  'zyxdy': {
    describe: true,
    suffix: 'Name',
    title: '营销单元',
    type: 'select',
    equation: city,
    dictionary: 'sale',
    width: 160
  },
  'zqdlx': {
    describe: true,
    suffix: 'TextView',
    title: '渠道类型',
    type: 'select',
    equation: city,
    dictionary: 'goodsPlanType'
  },
  'm1deliverynum': {
    title: '1月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm1approvingnum': {
    title: '1月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm1usednum': {
    title: '1月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm1remainnum': {
    title: '1月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm2deliverynum': {
    title: '2月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm2approvingnum': {
    title: '2月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm2usednum': {
    title: '2月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm2remainnum': {
    title: '2月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm3deliverynum': {
    title: '3月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm3approvingnum': {
    title: '3月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm3usednum': {
    title: '3月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm3remainnum': {
    title: '3月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm4deliverynum': {
    title: '4月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm4approvingnum': {
    title: '4月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm4usednum': {
    title: '4月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm4remainnum': {
    title: '4月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm5deliverynum': {
    title: '5月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm5approvingnum': {
    title: '5月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm5usednum': {
    title: '5月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm5remainnum': {
    title: '5月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm6deliverynum': {
    title: '6月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm6approvingnum': {
    title: '6月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm6usednum': {
    title: '6月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm6remainnum': {
    title: '6月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm7deliverynum': {
    title: '7月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm7approvingnum': {
    title: '7月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm7usednum': {
    title: '7月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm7remainnum': {
    title: '7月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm8deliverynum': {
    title: '8月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm8approvingnum': {
    title: '8月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm8usednum': {
    title: '8月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm8remainnum': {
    title: '8月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm9deliverynum': {
    title: '9月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm9approvingnum': {
    title: '9月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm9usednum': {
    title: '9月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm9remainnum': {
    title: '9月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm10deliverynum': {
    title: '10月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm10approvingnum': {
    title: '10月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm10usednum': {
    title: '10月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm10remainnum': {
    title: '10月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm11deliverynum': {
    title: '11月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm11approvingnum': {
    title: '11月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm11usednum': {
    title: '11月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm11remainnum': {
    title: '11月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm12deliverynum': {
    title: '12月发货计划量',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm12approvingnum': {
    title: '12月发货量(审核中)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm12usednum': {
    title: '12月发货量(归档)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'm12remainnum': {
    title: '12月发货计划剩余计划',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/shipmentPlanExecutionForms.js